module.exports = __webpack_public_path__ + "img/menuIcon9.f0ec11b1.png";